// ------------------------------------------------------------------------------- Global
// Global Data & Defs
import Defs from '../../../../../../includes/primitives/colorDefs'
import Filter from '../../../../../../includes/primitives/Filter_Defs'

import * as d3 from 'd3'

export default {
  data: () => ({
    dataSet: [],
    innerSvg: null,
    keyPlanSvg: null,
    Module: '41M001',
  }),
  computed: {

    ready2draw() {

      // console.log('------------------------------')
      // console.log('this.ChartType', this.ChartType)
      // console.log('this.DataItems.length', this.DataItems.length)
      // console.log('Object.keys(this.Canvas).length', Object.keys(this.Canvas).length)
      // console.log('Object.keys(this.Note).length', Object.keys(this.Note).length)
      // console.log('this.Status.length', this.Status.length)
      // console.log('this.Border.length', this.Border.length)

      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0 &&
        Object.keys(this.Note).length > 0
      )
    },

  },



  methods: {
    set_LocalValues(){
      this.dataSet = JSON.parse(JSON.stringify(this.DataItems))
      
      Filter.setDefs_DropShadow(this.svg, `barDropShadow___${this.localId}`, 2, .2 , 2, 2)
      
      let color_Ahead = this.svg
      .append('defs')
      .append('linearGradient').attr('id', `Ahead_Gradient___${this.localId}`).attr('x1', 0.5).attr('y1', 0.03).attr('x2', 0.5).attr('y2', 1.37)
      color_Ahead.append('stop').attr('stop-color', '#B3E5FC').attr('offset', '0')
      color_Ahead.append('stop').attr('stop-color', '#B3E5FC').attr('offset', '1')

      let color_Behind = this.svg
      .append('defs')
      .append('linearGradient').attr('id', `Behind_Gradient___${this.localId}`).attr('x1', 0.5).attr('y1', 0.03).attr('x2', 0.5).attr('y2', 1.37)
      // color_Behind.append('stop').attr('stop-color', '#fce3eb').attr('offset', '0')fcafc9
      color_Behind.append('stop').attr('stop-color', '#F8BBD0').attr('offset', '0')
      color_Behind.append('stop').attr('stop-color', '#F8BBD0').attr('offset', '1')
      
    },

    
    
    
  }
}